"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var mui_extension_1 = require("mui-extension");

var core_1 = require("@material-ui/core");

var autobind_decorator_1 = __importDefault(require("autobind-decorator"));

var Datatable_1 = require("./Datatable");

var react_redux_1 = require("react-redux");

var styles = function styles(t) {
  return core_1.createStyles({
    root: {
      background: t.palette.background.default
    }
  });
};

var DatatableHead =
/** @class */
function (_super) {
  __extends(DatatableHead, _super);

  function DatatableHead() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DatatableHead.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        criteria = _a.criteria,
        classes = _a.classes,
        selected = _a.selected,
        onSelect = _a.onSelect,
        isColumnVisible = _a.isColumnVisible;
    return React.createElement(mui_extension_1.TableSort, {
      className: classes.root,
      sortBy: criteria.sortBy,
      orderBy: criteria.orderBy,
      onSort: this.handleSortChange
    }, onSelect && React.createElement(mui_extension_1.TableSortCell, null, React.createElement(core_1.Checkbox, {
      checked: selected.length === criteria.limit,
      indeterminate: selected.length > 0 && selected.length < criteria.limit,
      onChange: this.handleSelect,
      style: {
        paddingTop: 0,
        paddingBottom: 0
      }
    })), React.Children.map(children, function (c, i) {
      return isColumnVisible(i) && c;
    }));
  };

  DatatableHead.prototype.componentDidMount = function () {
    this.publishColumns();
  };

  DatatableHead.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.children !== this.props.children) {
      this.publishColumns();
    }
  };

  DatatableHead.prototype.handleSelect = function () {
    var _a = this.props,
        selected = _a.selected,
        onSelect = _a.onSelect,
        criteria = _a.criteria;
    var newSelected = [];
    if (selected.length === 0) for (var i = 0; i < criteria.limit; i++) {
      newSelected.push(i);
    }
    onSelect(newSelected);
  };

  DatatableHead.prototype.handleSortChange = function (sortBy, orderBy) {
    var _a = this.props,
        dispatch = _a.dispatch,
        actions = _a.actions;
    dispatch(actions.sort(sortBy, orderBy));
  };

  DatatableHead.prototype.publishColumns = function () {
    var _a = this.props,
        children = _a.children,
        publishColumns = _a.publishColumns; // @ts-ignore

    publishColumns(React.Children.map(children, function (c) {
      return {
        label: c.props.children
      };
    }));
  };

  __decorate([autobind_decorator_1.default], DatatableHead.prototype, "handleSelect", null);

  __decorate([autobind_decorator_1.default], DatatableHead.prototype, "handleSortChange", null);

  return DatatableHead;
}(React.Component);

var state2props = function state2props(state, ownProps) {
  var paginateState = state.paginate[ownProps.name];
  return {
    criteria: paginateState.criteria,
    data: paginateState.entities
  };
};

exports.default = Datatable_1.datatableConsumer(core_1.withStyles(styles)(react_redux_1.connect(state2props)(DatatableHead)));